import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'

// Registers this module's `resume` namespace (see configs/i18n).
i18n.addResourceBundle('vi', 'resume', vi)
i18n.addResourceBundle('en', 'resume', en)
